// extracted by mini-css-extract-plugin
module.exports = {"root":"SortAdornment_root__hh5oI","icon":"SortAdornment_icon__2Vr6H","up":"SortAdornment_up__VZv_D","down":"SortAdornment_down__2LS1a","active":"SortAdornment_active__28htZ"};